import React, { useEffect, useState } from 'react';
import './webinar.css';
// import { CSSTransition } from 'react-transition-group';

const DisplayEmojis = (props) =>
{
	const { emojiValue, setEmojiValue } = props;

	const handleAnimation = (event) =>
	{
		event.stopPropagation();
		const updatedEmojiValue = [ ...emojiValue ];

		updatedEmojiValue.splice(0, 1);
		setEmojiValue(updatedEmojiValue);
	};

	// const handleAnimation = (id) =>
	// {
	// 	const updatedEmojiValue = emojiValue.filter((item) => item.id !== id);

	// 	setEmojiValue(updatedEmojiValue);
	// };

	// const handleAnimation = (id) => {
	// 	const updatedEmojiValue = emojiValue.map((item) => 
	// 		item.id === id ? { ...item, status: 'completed' } : item
	// 	);

	// 	setEmojiValue(updatedEmojiValue);
	// };

	// useEffect(() => {
	// 	const activeEmojis = emojiValue.filter(item => item.status !== 'completed');
	// 	setEmojiValue(activeEmojis);
	// }, [emojiValue]);

	return (
		<>
			{emojiValue.map((image, index) =>
				(
					<div className='floatDiv' key={image.id}
						onAnimationEnd={(e) => handleAnimation(e)}
					>
						<img src={`./emojis/${image.emoji}.svg`} alt='Emoji' />
					</div>
				))}

		</>
	);
};

export default DisplayEmojis;